export default __webpack_public_path__ + "static/media/oldtavern2.c19bafdf.jpg";